const mediaSettings = {
  list: [
    {
        'name': 'webm',
        'videoExt': 'webm',
        'audioExt': 'webm',
        'video':
        [
            {
                'name': 'VP9',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 5000000,
                        'resolution': '1080p'
                    },
                    'high':
                    {
                        'bitrate': 2500000,
                        'resolution': '720p'
                    },
                    'medium':
                    {
                        'bitrate': 1000000,
                        'resolution': '480p'
                    },
                    'low':
                    {
                        'bitrate': 500000,
                        'resolution': '240p'
                    }
                }
            },
            {
                'name': 'VP8',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 5000000,
                        'resolution': '1080p'
                    },
                    'high':
                    {
                        'bitrate': 2500000,
                        'resolution': '720p'
                    },
                    'medium':
                    {
                        'bitrate': 1000000,
                        'resolution': '480p'
                    },
                    'low':
                    {
                        'bitrate': 500000,
                        'resolution': '240p'
                    }
                }
            }
        ],
        'audio':
        [
            {
                'name': 'Opus',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 192000
                    },
                    'high':
                    {
                        'bitrate': 96000
                    },
                    'medium':
                    {
                        'bitrate': 48000
                    },
                    'low':
                    {
                        'bitrate': 24000
                    }
                }
            },
            {
                'name': 'Vorbis',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 192000
                    },
                    'high':
                    {
                        'bitrate': 96000
                    },
                    'medium':
                    {
                        'bitrate': 48000
                    },
                    'low':
                    {
                        'bitrate': 24000
                    }
                }
            }
        ]
    },
    {
        'name': 'x-matroska',
        'videoExt': 'mkv',
        'audioExt': 'mka',
        'video':
        [
            {
                'name': 'VP9',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 5000000,
                        'resolution': '1080p'
                    },
                    'high':
                    {
                        'bitrate': 2500000,
                        'resolution': '720p'
                    },
                    'medium':
                    {
                        'bitrate': 1000000,
                        'resolution': '480p'
                    },
                    'low':
                    {
                        'bitrate': 500000,
                        'resolution': '240p'
                    }
                }
            },
            {
                'name': 'VP8',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 5000000,
                        'resolution': '1080p'
                    },
                    'high':
                    {
                        'bitrate': 2500000,
                        'resolution': '720p'
                    },
                    'medium':
                    {
                        'bitrate': 1000000,
                        'resolution': '480p'
                    },
                    'low':
                    {
                        'bitrate': 500000,
                        'resolution': '240p'
                    }
                }
            },
            {
                'name': 'H.264',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 5000000,
                        'resolution': '1080p'
                    },
                    'high':
                    {
                        'bitrate': 2500000,
                        'resolution': '720p'
                    },
                    'medium':
                    {
                        'bitrate': 1000000,
                        'resolution': '480p'
                    },
                    'low':
                    {
                        'bitrate': 500000,
                        'resolution': '240p'
                    }
                }
            }
        ],
        'audio':
        [
            {
                'name': 'Opus',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 192000
                    },
                    'high':
                    {
                        'bitrate': 96000
                    },
                    'medium':
                    {
                        'bitrate': 48000
                    },
                    'low':
                    {
                        'bitrate': 24000
                    }
                }
            },
            {
                'name': 'Vorbis',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 192000
                    },
                    'high':
                    {
                        'bitrate': 96000
                    },
                    'medium':
                    {
                        'bitrate': 48000
                    },
                    'low':
                    {
                        'bitrate': 24000
                    }
                }
            },
            {
                'name': 'AAC',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 192000
                    },
                    'high':
                    {
                        'bitrate': 96000
                    },
                    'medium':
                    {
                        'bitrate': 48000
                    },
                    'low':
                    {
                        'bitrate': 24000
                    }
                }
            }
        ]
    },
    {
        'name': 'mp4',
        'videoExt': 'mp4',
        'audioExt': 'm4a',
        'video':
        [
            {
                'name': 'H.264',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 5000000,
                        'resolution': '1080p'
                    },
                    'high':
                    {
                        'bitrate': 2500000,
                        'resolution': '720p'
                    },
                    'medium':
                    {
                        'bitrate': 1000000,
                        'resolution': '480p'
                    },
                    'low':
                    {
                        'bitrate': 500000,
                        'resolution': '240p'
                    }
                }
            }
        ],
        'audio':
        [
            {
                'name': 'AAC',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 192000
                    },
                    'high':
                    {
                        'bitrate': 96000
                    },
                    'medium':
                    {
                        'bitrate': 48000
                    },
                    'low':
                    {
                        'bitrate': 24000
                    }
                }
            }
        ]
    },
    {
        'name': 'ogg',
        'audioExt': 'ogg',
        'audio':
        [
            {
                'name': 'Vorbis',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 192000
                    },
                    'high':
                    {
                        'bitrate': 96000
                    },
                    'medium':
                    {
                        'bitrate': 48000
                    },
                    'low':
                    {
                        'bitrate': 24000
                    }
                }
            },
            {
                'name': 'Opus',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 192000
                    },
                    'high':
                    {
                        'bitrate': 96000
                    },
                    'medium':
                    {
                        'bitrate': 48000
                    },
                    'low':
                    {
                        'bitrate': 24000
                    }
                }
            }
        ]
    },
    {
        'name': 'mp3',
        'audioExt': 'mp3',
        'audio':
        [
            {
                'name': 'MP3',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 320000
                    },
                    'high':
                    {
                        'bitrate': 192000
                    },
                    'medium':
                    {
                        'bitrate': 128000
                    },
                    'low':
                    {
                        'bitrate': 96000
                    }
                }
            }
        ]
    },
    {
        'name': 'avi',
        'videoExt': 'avi',
        'video':
        [
            {
                'name': 'MPEG-4',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 5000000,
                        'resolution': '1080p'
                    },
                    'high':
                    {
                        'bitrate': 2500000,
                        'resolution': '720p'
                    },
                    'medium':
                    {
                        'bitrate': 1000000,
                        'resolution': '480p'
                    },
                    'low':
                    {
                        'bitrate': 500000,
                        'resolution': '240p'
                    }
                }
            },
            {
                'name': 'Motion JPEG',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 5000000,
                        'resolution': '1080p'
                    },
                    'high':
                    {
                        'bitrate': 2500000,
                        'resolution': '720p'
                    },
                    'medium':
                    {
                        'bitrate': 1000000,
                        'resolution': '480p'
                    },
                    'low':
                    {
                        'bitrate': 500000,
                        'resolution': '240p'
                    }
                }
            }
        ],
        'audio':
        [
            {
                'name': 'PCM',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 192000
                    },
                    'high':
                    {
                        'bitrate': 96000
                    },
                    'medium':
                    {
                        'bitrate': 48000
                    },
                    'low':
                    {
                        'bitrate': 24000
                    }
                }
            },
            {
                'name': 'MP3',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 192000
                    },
                    'high':
                    {
                        'bitrate': 96000
                    },
                    'medium':
                    {
                        'bitrate': 48000
                    },
                    'low':
                    {
                        'bitrate': 24000
                    }
                }
            }
        ]
    },
    {
        'name': 'mov',
        'videoExt': 'mov',
        'video':
        [
            {
                'name': 'H.264',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 5000000,
                        'resolution': '1080p'
                    },
                    'high':
                    {
                        'bitrate': 2500000,
                        'resolution': '720p'
                    },
                    'medium':
                    {
                        'bitrate': 1000000,
                        'resolution': '480p'
                    },
                    'low':
                    {
                        'bitrate': 500000,
                        'resolution': '240p'
                    }
                }
            },
            {
                'name': 'ProRes',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 5000000,
                        'resolution': '1080p'
                    },
                    'high':
                    {
                        'bitrate': 2500000,
                        'resolution': '720p'
                    },
                    'medium':
                    {
                        'bitrate': 1000000,
                        'resolution': '480p'
                    },
                    'low':
                    {
                        'bitrate': 500000,
                        'resolution': '240p'
                    }
                }
            }
        ],
        'audio':
        [
            {
                'name': 'AAC',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 192000
                    },
                    'high':
                    {
                        'bitrate': 96000
                    },
                    'medium':
                    {
                        'bitrate': 48000
                    },
                    'low':
                    {
                        'bitrate': 24000
                    }
                }
            },
            {
                'name': 'PCM',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 192000
                    },
                    'high':
                    {
                        'bitrate': 96000
                    },
                    'medium':
                    {
                        'bitrate': 48000
                    },
                    'low':
                    {
                        'bitrate': 24000
                    }
                }
            }
        ]
    },
    {
        'name': '3gp',
        'videoExt': '3gp',
        'audioExt': '3gp',
        'video':
        [
            {
                'name': 'H.264',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 5000000,
                        'resolution': '1080p'
                    },
                    'high':
                    {
                        'bitrate': 2500000,
                        'resolution': '720p'
                    },
                    'medium':
                    {
                        'bitrate': 1000000,
                        'resolution': '480p'
                    },
                    'low':
                    {
                        'bitrate': 500000,
                        'resolution': '240p'
                    }
                }
            },
            {
                'name': 'MPEG-4',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 5000000,
                        'resolution': '1080p'
                    },
                    'high':
                    {
                        'bitrate': 2500000,
                        'resolution': '720p'
                    },
                    'medium':
                    {
                        'bitrate': 1000000,
                        'resolution': '480p'
                    },
                    'low':
                    {
                        'bitrate': 500000,
                        'resolution': '240p'
                    }
                }
            }
        ],
        'audio':
        [
            {
                'name': 'AAC',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 192000
                    },
                    'high':
                    {
                        'bitrate': 96000
                    },
                    'medium':
                    {
                        'bitrate': 48000
                    },
                    'low':
                    {
                        'bitrate': 24000
                    }
                }
            },
            {
                'name': 'AMR-NB',
                'quality':
                {
                    'ultra':
                    {
                        'bitrate': 12200
                    },
                    'high':
                    {
                        'bitrate': 12200
                    },
                    'medium':
                    {
                        'bitrate': 12200
                    },
                    'low':
                    {
                        'bitrate': 12200
                    }
                }
            }
        ]
    }
]};

mediaSettings.list.reduce((a,c)=>{
  a[c.name]=c;
  return a;
},mediaSettings);

export default mediaSettings;